<template>
  <div>
    <top />
    <router-view></router-view>
    <bottom :isEnroll="1"/>
  </div>
</template>

<script>
import Top from '@/components/enroll/Top'
import Bottom from "@/components/enroll/Bottom";
export default {
  name: "entrance",
  components:{
    Top,
    Bottom
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/enroll/entrance.vue